<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      border-variant="secondary"
      class="text-center mt-4"
    >
      <div class="col-sm-12">
        <h1 class="h1cimke">Leltár</h1>
        <div class="row">

          <div v-if="userType=='admin' || userType=='user'" class="col-sm-12">
            <!-- // NEW -->
            <b-button
              v-if="!list.length && !searchText"
              size="sm"
              variant="primary"
              class="btn float-right"
              @click="newInventory"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Új leltár készítése
            </b-button>

            <!-- // DELETE -->
            <b-button
              v-if="list.length || searchText"
              size="sm"
              variant="danger"
              class="btn float-right"
              @click="delInventory"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Leltár törlése
            </b-button>

            <!-- // CLOSE -->
            <b-button
              v-if="list.length || searchText"
              size="sm"
              variant="primary"
              class="btn float-right"
              @click="closeInventoryAllert"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Leltár lezárása
            </b-button>

              <b-button
                size="sm"
                class="btn float-right"
                variant="warning"
                @click="tableToExcel('table', 'Leltár')"
                ><b-icon-download></b-icon-download>
                Excel export
              </b-button>

          </div>

        </div>

        <!-- // SEARCH -->
        <b-row class="mt-3">
            <!-- // INPUT -->
            <div>
                <b-button-group>
                <b-button
                    size="sm"
                    class="btn float-left"
                    variant="outline-danger"
                    @click="$refs.searchInput.focus(), searchText='', filterSelect='', loadList(), cikkSelect = [], $refs.megnevezes_typeahead.inputValue = ''"
                    ><b-icon-x-circle></b-icon-x-circle>
                </b-button>
                </b-button-group>
            </div>

            <div class="col-sm-2">
                <b-form-input
                size="sm"
                class="form-control"
                ref="searchInput"
                v-model="searchText"
                placeholder="Írj ide valamit!"
                id="search"
                @click="searchText=''"
                @keyup.enter="search()"
                autofocus
                ></b-form-input>
            </div>

            <div>
                <b-button
                size="sm"
                class="btn float-left"
                variant="success"
                @click="search()"
                ><b-icon-search></b-icon-search>
                Keresés
                </b-button>
            </div>

            <!-- MENNYISÉG -->
            <div class="col-sm-2">
                <b-form-input
                    v-if="list.length === 1"
                    size="sm"
                    class="form-control"
                    ref="quantity"
                    v-model="mennyiseg"
                    placeholder="mennyiség"
                    id="search"
                    @click="searchText=''"
                    @keyup.enter="quantitySave()"
                    autofocus
                ></b-form-input>
            </div>

        </b-row>
      </div>

        <!-- // SEARCH NAME -->
        <div class="col-sm-12 mt-4">
            <vue-typeahead-bootstrap
                class="text-left"
                ref="megnevezes_typeahead"
                :maxMatches="100"
                :minMatchingChars="0"
                size="sm"
                :data="listAll"
                :serializer="item => `${item.nev} - vonalkód: ${item.vonalkod} - cikkszám: ${item.cikkszam} -  készlet: ${item.mennyiseg} -  fogyár: ${item.bruttofogyar} Ft`"
                @hit="cikkSelect = $event"
                @keyup="fillData"
                placeholder="terméknév"
                :disabledValues="(cikkSelect ? [cikkSelect.nev] : [])"
                />
        </div>

        <!-- TELJES LISTA -->
        <div class="col-sm-12 mt-4">
            <div>
                <b-button
                    size="sm"
                    class="btn float-right"
                    variant="success"
                    @click="loadList('ALL')"
                    ><b-icon-search></b-icon-search>
                    TELJES LISTA
                </b-button>
            </div>
        </div>

      <!-- // TABLE -->
      <div class="mt-3">
        <!-- // TÁBLA AZ EXCEL EXPORTHOZ -->
        <table  ref="listTable" hidden>
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Megnevezés</th>
                    <th>Cikkcsoport</th>
                    <th>Cikkszám</th>
                    <th>Vonalkód</th>
                    <th>Gyártó</th>
                    <th>egys.</th>
                    <th>Nettó besz.ár</th>
                    <th>Bruttó fogy.ár</th>
                    <th>DB</th>
                    <th>Készlet érték</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(element) in list" :key="element.id">
                  <td>{{element.id}}</td>
                    <td>{{element.nev}}</td>
                    <td>{{element.csikkCsoport}}</td>
                    <td>{{element.cikkszam}}</td>
                    <td>{{element.vonalkod}}</td>
                    <td>{{element.gyarto}}</td>
                    <td>{{element.mennyisegiegyseg}}</td>
                    <td>{{element.nettobeszar}}</td>
                    <td>{{element.bruttofogyar}}</td>
                    <td>{{element.mennyiseg}}</td>
                    <td>{{element.keszletertek}}</td>
                </tr>
            </tbody>
        </table>

        <b-table  class="labelsize table-striped"
            :tbody-tr-class="inventoryCssFn"
            hover
            @row-clicked="tableRowClick"
            :items="list"
            :fields="fields"
            :key="list.id"
        >

          <!-- // EDIT -->
          <template v-if="userType=='admin' || userType=='user'" v-slot:cell(edit)="row">
            <b-button v-if="row.item.closed != 1"
              size="sm"
              @click="
                $router.push({
                  name: 'LeltarNew',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-0"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // NETTÓ BESZÁR -->
          <template v-slot:cell(nettobeszar)="row" class="mb-1">
            <p v-show="beszArShow=='1'">{{row.item.nettobeszar}}</p>
          </template>

          <!-- // DELETE -->
          <template v-slot:cell(del)="row" class="mb-1">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>

    </b-card>

    <b-modal id="spinner-modal" size="xl" title="" hide-footer hide-header no-close-on-backdrop>
        <div class="text-center">
            Adatok betöltése folyamatban...
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import VueHtml2pdf from 'vue-html2pdf'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { BSpinner } from 'bootstrap-vue'

export default {
  components: {
    VueHtml2pdf,
    BSpinner
  },
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      dateconvert: null,
      EgyebTetelekShow: false,
      tableHeadShow: false,
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      filters: [
        'Minden oszlop',
        'Megnevezés'
      ],
      list: [],
      listAll: [],
      fields: [
        // {
        //   key: 'id',
        //   label: 'Id',
        //   sortable: true
        //   // sortDirection: 'asc'
        // },
        // {
        //   key: 'emaillink',
        //   label: 'CRM',
        //   sortable: true,
        //   sortDirection: 'desc',
        //   tdClass: 'text-right',
        //   thClass: 'text-right'
        // },
        {
          key: 'nev',
          label: 'Megnevezés',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'csikkCsoport',
          label: 'Cikkcsoport',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'cikkszam',
          label: 'Cikkszám',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'vonalkod',
          label: 'Vonalkód',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'gyarto',
          label: 'Gyártó',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'mennyisegiegyseg',
          label: 'egys.',
          sortable: true,
          thClass: 'text-left'
        },
        {
          key: 'nettobeszar',
          label: 'Nettó besz.ár',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'bruttofogyar',
          label: 'Bruttó fogy.ár',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'mennyiseg',
          label: 'DB',
          sortable: true
          // thClass: 'text-left'
        },
        {
          key: 'keszletertek',
          label: 'Készlet érték',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        { key: 'edit', sortable: false }
        // { key: 'del', sortable: false }
      ],
      myTempAnyagTipus: [],
      searchText: '',
      filterSelect: '',
      beszArShow: 1,
      mennyiseg: '',
      cikkSelect: [],
      query: '',
      inventoryCss: 'labelsize table-striped',
      uri: 'data:application/vnd.ms-excel;base64,',
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urns:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function (s) { return window.btoa(unescape(encodeURIComponent(s))) },
      format: function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p] }) }
    }
  },
  methods: {
    inventoryCssFn (item) {
      if (item.mennyiseg === 0) {
        return 'red'
      }
    },
    typeaheadHit () {
      this.listAll.nev = this.$refs.megnevezes_typeahead.inputValue
    },
    fillData: function () {
      this.searchText = this.cikkSelect.nev
      this.search()
    },
    tableRowClick (item, index, event) {
      this.searchText = item.nev
      this.search()
    },
    quantitySave () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (this.list.length === 1) {
          this.list[0].mennyiseg = this.mennyiseg
          payload.token = this.token
          payload.userType = this.userType
          payload.mennyiseg = this.mennyiseg
          payload.id = this.list[0].id
          axios.post(process.env.ROOT_API + '/leltar/quantitysave', {payload})
            .then(res => {
              if (res.data.result === 'OK') {
                this.$refs.searchInput.focus()
                this.list = []
                this.searchText = ''
                this.mennyiseg = ''
                this.cikkSelect = []
                this.$refs.megnevezes_typeahead.inputValue = ''
                this.loadList()
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    },
    newInventory () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        this.$bvModal.show('spinner-modal')
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API + '/leltar/newinventory', {payload})
          .then(res => {
            if (res.data === 'OK') this.loadList()
            this.$bvModal.hide('spinner-modal')
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    delInventory: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req

        this.$bvModal
          .msgBoxConfirm('Ez a művelet törli az aktuáli leltár listát! Kezdeheted előről a leltározást! ', {
            title: 'Biztos törlöni akarod?',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'IGEN',
            cancelTitle: 'NEM',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              axios
                .post(process.env.ROOT_API + '/leltar/delinventory', { payload })
                .then(res => {
                  this.list = []
                  if (res.data === 'OK') this.loadList()
                })
                .catch(err => {
                  console.log(err)
                })
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    closeInventory () {
      console.log('DD')
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        this.$bvModal.show('spinner-modal')
        payload.token = this.token
        payload.userType = this.userType
        axios.post('http://' + process.env.ROOT_API + '/leltar/closeInventory', {payload})
          .then(res => {
            if (res.data === 'OK') this.loadList()
            this.$bvModal.hide('spinner-modal')
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    closeInventoryAllert (id, partner) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Biztos, hogy lezárod a leltárt? Ezzel a lépéssel felülírod az éles készletet a leltári készlettel.', {
          title: 'Figyelem!',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.closeInventory()
        })
        .catch(err => {
          console.log(err)
        })
    },
    tableToExcel (table, name) {
      if (!table.nodeType) table = this.$refs.listTable
      var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
      var link = document.createElement('a')
      let thisyear = moment().format('YYYY')
      link.download = `Leltar.xls`
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
    },
    showNetto () {
      if (this.beszArShow === 0) {
        this.beszArShow = 1
      } else {
        this.beszArShow = 0
      }
    },
    search () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (this.searchText) {
          payload.token = this.token
          payload.userType = this.userType
          payload.filter = this.filterSelect
          payload.searchText = this.searchText
          axios.post(process.env.ROOT_API + '/leltar/search', {payload})
            .then(res => {
              this.list = []
              for (var el in res.data) {
                this.list.push({
                  id: res.data[el].id,
                  nev: res.data[el].nev,
                  csikkCsoport: res.data[el].csikkCsoportModel.megnevezes,
                  cikkszam: res.data[el].cikkszam,
                  vonalkod: res.data[el].vonalkod,
                  gyarto: res.data[el].gyartoModel.megnevezes,
                  mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                  nettobeszar: res.data[el].nettobeszar,
                  bruttofogyar: res.data[el].bruttofogyar,
                  mennyiseg: res.data[el].mennyiseg,
                  keszletertek: res.data[el].bruttofogyar * res.data[el].mennyiseg
                })
              }
              this.mennyiseg = ''
              this.$refs.quantity.focus()
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    },
    redirect: function (link, target = '_blank') {
      window.open(link, target)
    },
    printPDF (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios.post(process.env.ROOT_API + '/leltar/pdf', {payload})
          .then(res => {
            this.myTempAnyagTipus = res.data.client
            if (this.myTempAnyagTipus.cikkTetels.length > 0) {
              this.EgyebTetelekShow = true
            } else { this.EgyebTetelekShow = false }
            this.$refs.html2Pdf.generatePdf()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post(process.env.ROOT_API + '/leltar/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (id, partner) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('(ID:' + id + ') ' + partner, {
          title: 'Biztos törlöni akarod?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(id)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList (mode) {
      let payload = {}
      let URL
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (mode === 'ALL') {
          this.$bvModal.show('spinner-modal')
          URL = '/leltar/getlistall'
        } else {
          URL = '/leltar/getlist'
        }
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API + URL, {payload})
          .then(res => {
            for (var el in res.data) {
              this.list.push({
                id: res.data[el].id,
                nev: res.data[el].nev,
                csikkCsoport: res.data[el].csikkCsoportModel.megnevezes,
                cikkszam: res.data[el].cikkszam,
                vonalkod: res.data[el].vonalkod,
                gyarto: res.data[el].gyartoModel.megnevezes,
                mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                nettobeszar: res.data[el].nettobeszar,
                bruttofogyar: res.data[el].bruttofogyar,
                mennyiseg: res.data[el].mennyiseg,
                keszletertek: res.data[el].bruttofogyar * res.data[el].mennyiseg
              })
            }
            this.$bvModal.hide('spinner-modal')
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    loadListAll () {
      let payload = {}
      let URL
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        URL = '/leltar/getlistall'
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API + URL, {payload})
          .then(res => {
            for (var el in res.data) {
              this.listAll.push({
                id: res.data[el].id,
                nev: res.data[el].nev,
                csikkCsoport: res.data[el].csikkCsoportModel.megnevezes,
                cikkszam: res.data[el].cikkszam,
                vonalkod: res.data[el].vonalkod,
                gyarto: res.data[el].gyartoModel.megnevezes,
                mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                nettobeszar: res.data[el].nettobeszar,
                bruttofogyar: res.data[el].bruttofogyar,
                mennyiseg: res.data[el].mennyiseg,
                keszletertek: res.data[el].bruttofogyar * res.data[el].mennyiseg
              })
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
    this.loadListAll()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Leltar.vue